import { Link } from 'react-router-dom';

interface FooterLinkProps {
  to: string;
  view: string;
}

/** 푸터 SNS 아이콘 링크 (새 창) */
export const FooterLinkIcon = ({ to, view }: FooterLinkProps) => {
  return (
    <Link to={to} target="_blank">
      <img
        alt="Frame"
        src={process.env.PUBLIC_URL + view}
        className="w-10 lg:w-[60PX]"
      />
    </Link>
  );
};
